module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_8.884412c4.svg";